module.exports = "/_next/static/media/362157d6901f3f45cf02ee40c19068a6.svg";